import { Link } from "react-router-dom";
import { Linkedin, Mail, ArrowUpRight } from "lucide-react";

const EMAIL = "nishantgathwal@gmail.com";
const LINKEDIN = "https://www.linkedin.com/in/nishant-gathwal-8494b047/";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-ink">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-16 lg:py-24">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-6">
            <p className="text-ash text-sm tracking-widest uppercase mb-4">Let's talk</p>
            <a
              href={`mailto:${EMAIL}`}
              data-testid="footer-email-link"
              className="font-heading font-light text-3xl sm:text-4xl lg:text-5xl tracking-tight text-cream hover:text-white transition-colors break-words"
            >
              {EMAIL}
            </a>
          </div>

          <div className="lg:col-span-3">
            <p className="text-ash text-sm tracking-widest uppercase mb-5">Sitemap</p>
            <ul className="space-y-3">
              {[
                { to: "/work", label: "Work" },
                { to: "/playground", label: "Playground" },
                { to: "/about", label: "About" },
                { to: "/contact", label: "Contact" },
              ].map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    className="text-cream/80 hover:text-cream transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="text-ash text-sm tracking-widest uppercase mb-5">Elsewhere</p>
            <ul className="space-y-3">
              <li>
                <a
                  href={LINKEDIN}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-linkedin-link"
                  className="group inline-flex items-center gap-2 text-cream/80 hover:text-cream transition-colors"
                >
                  <Linkedin size={16} /> LinkedIn
                  <ArrowUpRight size={14} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${EMAIL}`}
                  data-testid="footer-mail-link"
                  className="inline-flex items-center gap-2 text-cream/80 hover:text-cream transition-colors"
                >
                  <Mail size={16} /> Email
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-ash text-sm">
            &copy; {new Date().getFullYear()} Nishant Gathwal. Designed in New Delhi.
          </p>
          <p className="text-ash/70 text-sm">UX Designer &middot; HR & Enterprise</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
